export const TRANSPORT_TYPE_OPTIONS = [
    { value: 'dry-van', label: 'Dry Van' },
    { value: 'reefer', label: 'Reefer' },
    { value: 'flatbed', label: 'Flatbed' },
    { value: 'super-b', label: 'Super-B' },
]
